import { Icons, List, ListItem } from '@healthinal/ui';
import { MenuLink } from '../../../../components/MenuLink.tsx';

export function ContactTracingSideNavigation({ patientId }: { patientId: string }) {
  return (
    <List sx={{ maxWidth: 208, p: 0, '--ListItem-radius': '8px', textDecoration: 'none' }}>
      <ListItem>
        <MenuLink
          icon={<Icons.AccountCircle />}
          to="/contact-tracing/$patientId"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId } as const}
          replace
          activeOptions={{ exact: true }}>
          Personalien
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.Description />}
          to="/contact-tracing/$patientId/document"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId } as const}
          replace>
          Dokumente
        </MenuLink>
      </ListItem>
    </List>
  );
}
